<template>
	<v-dialog v-model="dialog" max-width="800px" persistent>
		<v-card class="justify-center text-center card-rounded pb-5" style="width: 100%; height: auto">
			<v-card-title class="pa-2 white--text justify-center text-center secondary">
				<v-spacer />
				Request a Permanent Placement
				<v-spacer />
				<v-icon icon @click="close">mdi-close</v-icon>
				<v-card-subtitle class="pa-2 white--text justify-center text-center secondary"
					>Fill the details of your request in below and our Client Success team will be in contact shortly</v-card-subtitle
				>
			</v-card-title>

			<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
				<v-form v-model="valid">
					<v-row>
						<v-col>
							<v-text-field v-model="practiceName" label="Practice Name" disabled class="my-text-field"></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field v-model="practiceBussinessEmail" label="Practice email address" disabled class="my-text-field"></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field v-model="professionTitle" label="Profession/Job Title" class="my-text-field"></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field v-model="monthlySalary" label="Monthly salary range" class="my-text-field"></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field v-model="workingHours" label="Working hours" class="my-text-field"></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field
								v-model="message"
								label="Description of position and additional information"
								messages="Example: Years of experience, languages, additional certifications"
								class="text-wrap my-text-field"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-btn
							:disabled="!validForm"
							large
							class="button-rounded continue-signup-button text-none"
							style="text-transform: none !important"
							color="primary"
							@click="SubmitForm()"
							>{{ 'Submit' }}
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import store from '@/store';
export default {
	name: 'RequestDialog',

	data() {
		return {
			dialog: false,
			practiceName: null,
			practiceBussinessEmail: null,
			professionTitle: null,
			monthlySalary: null,
			workingHours: null,
			message: null,
			valid: false,
		};
	},
	computed: {
		company() {
			return store.getters.company || {};
		},
		user() {
			return store.getters.user || {};
		},
		validForm() {
			return this.valid && !!this.practiceBussinessEmail && !!this.professionTitle && !!this.monthlySalary && !!this.workingHours;
		},
	},

	mounted() {
		const { name, email } = this.company;
		this.practiceName = name;
		this.practiceBussinessEmail = email;
	},

	methods: {
		...mapActions('company', ['RequestPermanentPlacement']),
		open() {
			this.dialog = true;
		},

		close() {
			this.dialog = false;
		},

		async SubmitForm() {
			// Send mail to LB Admin
			const placementDetails = {
				practiceName: this.practiceName,
				practiceBussinessEmail: this.practiceBussinessEmail,
				professionTitle: this.professionTitle,
				monthlySalary: this.monthlySalary,
				workingHours: this.workingHours,
				message: this.message,
			};
			await this.RequestPermanentPlacement(placementDetails);
			this.close();
		},
	},
};
</script>
<style>
.my-text-field label {
	color: black !important;
}
</style>
